import { Star } from "lucide-react";

// Link para o visitante adicionar a OP2P como fonte preferida no Google.
// O botão oficial do Google só renderiza se o publisher.js injetar o elemento;
// como fallback, exibimos o link com a frase e o ícone de estrela.
export function PreferredSourceButton() {
  return (
    <a
      href="https://www.google.com/preferences/source?q=op2p.ai"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
      aria-label="Adicionar OP2P como fonte preferida no Google"
      title="Adicionar OP2P como fonte preferida no Google"
    >
      <Star className="w-4 h-4 fill-current" />
      <span>Adicionar OP2P como fonte preferida no Google</span>
    </a>
  );
}
